import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';

export class AufnahmebogenWasser extends Aufnahmebogen {

    protected dataIgnored: any = {};

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.initData(IDs.ENT_ENERGIEDATEN_WASSER);
            this.setJahre();
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => item.jahr);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(row.jahr) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.fremdbezug
            || row.kosten_abwasser
            || row.kosten_bezug
            || row.regen_brunnennutzung
            || row.rueckerstattung
        );
    }

    protected getEinheitTid(): string {
        return ((this.dataDb[IDs.ENT_ENERGIEDATEN_WASSER_EINHEITEN] || [])
            .find((einheit: any) => einheit.name === this.getEinheit()) || {}).tid || null;
    }

    private setData(): void {
        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (index > 0) {
                this.setBemerkung();
            }

            switch (titel) {
                case 'Abrechnungszeitraum':
                    this.setAbrechnungszeitraum();
                    break;
                case 'Fremdbezug':
                    this.setFremdbezug();
                    break;
                case 'Regennutzung':
                    this.setValue('regen_brunnennutzung', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].regen_brunnennutzung = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Abwasser/Niederschlag        Kosten':
                    this.setValue('kosten_abwasser', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].kosten_abwasser = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Rückerstattung':
                    this.setValue('rueckerstattung', (value: any, index: number) => {
                        if (typeof value === 'number') {
                            this.data[this.curEntity][index].rueckerstattung = +value.toFixed(2);
                        }
                    });
                    break;
                case 'Mess-System (Kalibrierung)':
                    this.setValue('messsystem');
                    break;
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_ENERGIEDATEN_WASSER;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
            }
        });
    }

    protected setFremdbezug(): void {
        this.setValue('fremdbezug', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].fremdbezug = +value.toFixed(2);
            }
            this.data[this.curEntity][index].einheit_tid = this.getEinheitTid();
        });
        ++this.curRowIndex;
        this.setValue('kosten_bezug', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].kosten_bezug = +value.toFixed(2);
            }
        });
    }
}
